<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_19213_13972)">
			<path
				d="M3.78261 6.34765L20.2174 6.34766C20.6478 6.34766 21 5.99548 21 5.56505C21 4.7006 20.2992 3.99983 19.4348 3.99983L4.56522 3.99983C3.70077 3.99983 3 4.7006 3 5.56505C3 5.99548 3.35217 6.34765 3.78261 6.34765Z"
				:fill="props.iconColor"
			/>
			<path
				d="M20.216 13.3917V7.53086C20.216 7.30995 20.0369 7.13086 19.816 7.13086H4.18125C3.96034 7.13086 3.78125 7.30995 3.78125 7.53086V13.3917C3.78125 15.5517 5.53429 17.3048 7.69429 17.3048H11.5369L11.2943 17.6961L11.0517 18.0874L9.71342 20.2278C9.59995 20.4117 9.65473 20.6504 9.83864 20.7678C10.0226 20.8813 10.2613 20.8265 10.3786 20.6426L11.9752 18.0874L12.0026 18.0443L12.0299 18.0874L13.6265 20.6426C13.7008 20.76 13.8299 20.8265 13.9591 20.8265C14.0295 20.8265 14.0999 20.8069 14.1665 20.7678C14.3504 20.6543 14.4052 20.4117 14.2917 20.2278L12.9534 18.0874L12.7108 17.6961L12.4682 17.3048H16.3108C18.4708 17.3048 20.2239 15.5517 20.2239 13.3917H20.216ZM10.2378 11.2043L6.48712 14.955C6.33476 15.1073 6.08774 15.1073 5.93538 14.955C5.78302 14.8026 5.78302 14.5556 5.93538 14.4033L9.95884 10.3798C10.1151 10.2236 10.3683 10.2236 10.5245 10.3798L13.3721 13.2274L17.1247 9.47477H15.7199C15.5038 9.47477 15.3286 9.29958 15.3286 9.08347C15.3286 8.86736 15.5038 8.69216 15.7199 8.69216H18.0678C18.283 8.69216 18.4591 8.86825 18.4591 9.08347V11.4313C18.4591 11.6474 18.2839 11.8226 18.0678 11.8226C17.8517 11.8226 17.6765 11.6474 17.6765 11.4313V10.0265L13.655 14.048C13.4988 14.2042 13.2455 14.2042 13.0893 14.048L10.2417 11.2004L10.2378 11.2043Z"
				:fill="props.iconColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_19213_13972">
				<rect width="18" height="16.8261" :fill="props.iconColor" transform="translate(3 4)" />
			</clipPath>
		</defs>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
